
export const isSlsOffline = () => {
    return process.env.API_SOURCE_SLS_OFFLINE === 'true' || false;
};

// get the value in minutes
export const getProjectIssueCacheExpiry = () => {
    return process.env.PROJECT_ISSUE_CACHE_EXPIRY || 0;
};

// get the value in minutes
export const getProjectCacheExpiry = () => {
    return process.env.PROJECT_CACHE_EXPIRY || 0;
};



// WEBPACK FOOTER //
// ./services/environment.js